<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/business-phone-system-with-crm.mjs";
</script>
